import React, { useMemo } from "react";

import { ViewLessonContent } from "./lesson";
import { ViewAssessmentContent } from "./assessment";
import { LearningRecordCourse } from "src/types/coaching/learners";

import { CourseContext } from "../../context";
import { Assessment, PodcastLesson, Section, SimulationLesson } from "src/types/coaching/courses";
import { ViewPodcastContent } from "./podcast";
import { ViewSimulationContent } from "./simulation";

import _ from "lodash";
import styles from "./content.module.scss";

interface ViewCourseContentProps {
  course: LearningRecordCourse;
  collapsed: boolean;
  onSimulatorModeChange?: (isSimulator: boolean) => void;
}

export const ViewCourseContent: React.FC<ViewCourseContentProps> = ({course, collapsed, onSimulatorModeChange}) => {
  const courseContext = React.useContext(CourseContext);
  const courseContent = courseContext.courseContent;
  
  const entityType = useMemo(() => {
    return _.get(courseContent, "entityType");
  }, [courseContent]);

  return (
    <div className={styles.content}>
      {courseContent && entityType === "lesson" && (
        <ViewLessonContent key={courseContent.id} course={course} lesson={courseContent} collapsed={collapsed}/>
      )}

      {courseContent && entityType === "assessment" && (
        <ViewAssessmentContent key={courseContent.id} course={course} assessment={courseContent as Assessment} collapsed={collapsed} />
      )}

      {courseContent && entityType === "simulation" && (
        <ViewSimulationContent key={courseContent.id} course={course} content={courseContent as SimulationLesson} onSimulatorModeChange={onSimulatorModeChange} />
      )}

      {courseContent && entityType === "podcast" && (
        <ViewPodcastContent key={courseContent.id} course={course} content={courseContent as PodcastLesson}  />
      )}
    </div>
  );
}